import React, { useContext } from "react";
import "./MovieList.scss";
import { img_300, unavailable } from "../../config/config";
import { MovieIndexContext } from "../../context/MovieIndexContext";

const MovieList = ({ movieIndex, title, poster, setValue }) => {
  // eslint-disable-next-line
  const { setMovieIndex } = useContext(MovieIndexContext);
  const clickEventHandler = () => {
    setMovieIndex(movieIndex);
    console.log(movieIndex);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    setValue("2");
  };
  // console.log(clickEventHandler);

  return (
    <div className="movies-list">
      <div className="movies-list__movies-img" onClick={clickEventHandler}>
        <img
          src={poster ? `${img_300}/${poster}` : unavailable}
          alt="movies-poster"
        />
      </div>
      <div className="movies-list__movies-desc">
        <div className="movies-list__movies-detail">
          <h4 className="movies-list__name" onClick={clickEventHandler}>
            {title}
          </h4>
          <h4 className="movies-list__genre">Sci-Fi, Action</h4>
        </div>
        <div className="movies-list__movies-rating">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/IMDB_Logo_2016.svg/640px-IMDB_Logo_2016.svg.png"
            alt="imdb-logo"
          />
          <h4 className="movies-list__point">8.9</h4>
        </div>
      </div>
    </div>
  );
};

export default MovieList;
